import React from 'react';

import Head from 'next/head';

import { connect } from 'react-redux';

import { array, number } from 'prop-types';
import generate from 'shortid';

const getDefaultLinks = (siteId) => [
  {
    rel: 'manifest',
    href: `https://services.smartbr.com/api/v1/site/${siteId}/manifest`,
  },
  {
    rel: 'preconnect',
    href: 'https://cdn.smartbr.com',
  },
  {
    rel: 'preconnect',
    href: 'https://services.smartbr.com',
  },
  {
    rel: 'preconnect',
    href: 'https://ocean-services.smartbr.com',
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '57x57',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-57x57.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '60x60',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-60x60.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '72x72',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-72x72.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '76x76',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-76x76.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '114x114',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-114x114.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '120x120',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-120x120.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '144x144',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-144x144.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '152x152',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-152x152.png`,
  },
  {
    type: 'image/png',
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: `https://cdn.smartbr.com/${siteId}/apple-icon-180x180.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: `https://cdn.smartbr.com/${siteId}/favicon-16x16.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: `https://cdn.smartbr.com/${siteId}/favicon-32x32.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '48x48',
    href: `https://cdn.smartbr.com/${siteId}/favicon-48x48.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '96x96',
    href: `https://cdn.smartbr.com/${siteId}/favicon-96x96.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: `https://cdn.smartbr.com/${siteId}/logotipo_preferencial-192x192.png`,
  },
];

const LinkTags = ({ links, siteId }) => (
  <Head key="mongodb-links">
    {getDefaultLinks(siteId).map((lnk) => (
      <link key={generate()} {...lnk} />
    ))}
    {links && links.map((lnk) => <link key={generate()} {...lnk} />)}
  </Head>
);

LinkTags.defaultProps = {
  links: [],
};

LinkTags.propTypes = {
  links: array,
  siteId: number,
};

const mapStateToProps = ({ app }) => ({
  links: app.getIn(['config', 'links'], []),
  siteId: app.getIn(['config', 'siteId']),
});

export default connect(mapStateToProps)(LinkTags);
